import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { DetalleConvocatoriaAyudantiasDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class DetalleConvocatoriaAyudantiasService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getDetalleConvocatoriaAyudantiasService(): Observable<BodyListResponse<DetalleConvocatoriaAyudantiasDTO>> {
    return this.http.get<BodyListResponse<DetalleConvocatoriaAyudantiasDTO>>(API_URL + '/api/v1/detalleConvocatoriaAyudantias/todos');
  }


  
  guardarDetalleConvocatoriaAyudantiasService(detalleConvocatoriaAyudantiasDTO: DetalleConvocatoriaAyudantiasDTO): Observable<BodyResponse<DetalleConvocatoriaAyudantiasDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/detalleConvocatoriaAyudantias', detalleConvocatoriaAyudantiasDTO);
  }

  getDetalleConvocatoriaAyudantiasPorCodigoService(codigo: string): Observable<BodyResponse<DetalleConvocatoriaAyudantiasDTO>> {
    return this.http.get<BodyResponse<DetalleConvocatoriaAyudantiasDTO>>(API_URL + '/api/v1/detalleConvocatoriaAyudantias/' + codigo);
  }

  getDetalleConvocatoriaAyudantiasPoConvocatoriaService(codigo: string): Observable<BodyListResponse<DetalleConvocatoriaAyudantiasDTO>> {
    return this.http.get<BodyListResponse<DetalleConvocatoriaAyudantiasDTO>>(API_URL + '/api/v1/detalleConvocatoriaAyudantias/codigoConvocatoria/' + codigo)
  }

  getDetalleConvocatoriaAyudantiasPoConvocatoriaEscuelaService(codigo: string, codigoEscuela: string): Observable<BodyListResponse<DetalleConvocatoriaAyudantiasDTO>> {
    return this.http.get<BodyListResponse<DetalleConvocatoriaAyudantiasDTO>>(API_URL + '/api/v1/detalleConvocatoriaAyudantias/codigoConvocatoriaEscuela/' + codigo + '/' + codigoEscuela)
  }

  

}
